<template>
  <Header hide-search hide-filters />
</template>

<script>
import Header from '@/components/header/headers/Header'

export default {
  name: 'SimpleHeader',

  components: {
    Header,
  },
}
</script>
